module.exports = __webpack_public_path__ + "static/ficosec-3-f6ce1f2a3539ae096b5e20d4fb3c016c.jpg";